import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['ricePaddy', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-1,-3.5h0.5v1h-0.5zM-2.5,-3h0.5v0.5h-0.5zM0.5,-2.5h0.5v0.5h-0.5zM-3.5,-2h0.5v0.5h-0.5zM2,-2h0.5v0.5h-0.5zM-2.5,-1.5h0.5v0.5h-0.5zM2.5,-1.5h1v0.5h-1zM-5,-1h1.5v0.5h-1.5zM-1,-1h0.5v1h-0.5zM0.5,-1h0.5v0.5h-0.5zM3.5,-1h1.5v0.5h-1.5zM-4.5,-0.5h1v0.5h-1zM3.5,-0.5h1v0.5h-1zM-3.5,0h1v0.5h-1zM2.5,0h1v0.5h-1zM-2.5,0.5h1v0.5h-1zM1.5,0.5h0.5v0.5h-0.5zM-1.5,1h1v0.5h-1zM0.5,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'ricePaddy',
      d: 'M-5,-0.5h0.5v0.5h-0.5zM-5,0h1.5v0.5h-1.5zM-4,0.5h1.5v0.5h-1.5zM2,0.5h0.5v0.5h-0.5zM-3,1h1.5v0.5h-1.5zM1,1h0.5v0.5h-0.5zM-2,1.5h2.5v0.5h-2.5zM-1,2h1v0.5h-1z',
    },
    {
      paint: [
        ['ricePaddy', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M4.5,-0.5h0.5v0.5h-0.5zM3.5,0h1.5v0.5h-1.5zM2.5,0.5h1.5v0.5h-1.5zM1.5,1h1.5v0.5h-1.5zM0.5,1.5h1.5v0.5h-1.5zM0,2h1v0.5h-1z',
    },
    {
      paint: 'ricePaddyWater',
      d: 'M0,-2h0.5v0.5h-0.5zM1.5,-1.5h0.5v0.5h-0.5zM-3.5,-1h1v0.5h-1zM-0.5,-1h0.5v0.5h-0.5zM1,-1h2.5v0.5h-2.5zM-3.5,-0.5h2v0.5h-2zM0,-0.5h3.5v0.5h-3.5zM-2.5,0h1.5v0.5h-1.5zM-0.5,0h3v0.5h-3zM-1.5,0.5h3v0.5h-3zM-0.5,1h1v0.5h-1z',
    },
    {
      paint: 'reeds',
      d: 'M-1,-4h0.5v0.5h-0.5zM-2.5,-3.5h0.5v0.5h-0.5zM-1.5,-3.5h0.5v0.5h-0.5zM-0.5,-3.5h0.5v0.5h-0.5zM0.5,-3.5h0.5v0.5h-0.5zM-3,-3h0.5v0.5h-0.5zM-2,-3h1v0.5h-1zM-0.5,-3h2v0.5h-2zM2,-3h0.5v0.5h-0.5zM-3.5,-2.5h4v0.5h-4zM1,-2.5h2v0.5h-2zM-4.5,-2h1v0.5h-1zM-3,-2h3v0.5h-3zM0.5,-2h1.5v0.5h-1.5zM2.5,-2h0.5v0.5h-0.5zM-4,-1.5h1.5v0.5h-1.5zM-2,-1.5h3.5v0.5h-3.5zM2,-1.5h0.5v0.5h-0.5zM-2.5,-1h1.5v0.5h-1.5zM0,-1h0.5v0.5h-0.5zM-1.5,-0.5h0.5v0.5h-0.5zM-0.5,-0.5h0.5v0.5h-0.5zM-1,0h0.5v0.5h-0.5z',
    },
  ],
  pixels: 159,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
